import { CourseEvent } from "../../models/CourseEvent";
import Collapse from "react-bootstrap/esm/Collapse";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import Navbar from "react-bootstrap/esm/Navbar";
import Nav from "react-bootstrap/esm/Nav";
import ListGroup from "react-bootstrap/esm/ListGroup";
import { Bell, ClipboardData, Collection, EnvelopePaper, Hourglass, Link, Mortarboard, PersonAdd } from "react-bootstrap-icons";
import { UserRegistrationList } from "./UserRegistrationList";
import { BulkSurvey } from "./modal/BulkSurvey";
import { useContext, useEffect, useState } from "react";
import { SurveyResponsesView } from "./modal/SurveyResponsesView";
import { ManualRegistration } from "./modal/ManualRegistration";
import { WaitlistView } from "./modal/WaitlistView";
import { SessionContext } from "../../context/SessionContext";
import { ConfirmSendReminder } from "./modal/ConfirmSendReminder";
import { ConfirmSendLink } from "./modal/ConfirmSendLink";
import { ConfirmSendSurvey } from "./modal/ConfirmSendSurvey";
import { ConfirmSendCertificates } from "./modal/ConfirmSendCertificates";

export const CourseEventExpandable: React.FC<{rowData: CourseEvent, i: number, open: boolean, initiateParentReload: () => void}> = ({rowData, i, open, initiateParentReload}) => {
    const [showBulkSurvey, setShowBulkSurvey] = useState(false);
    const [showSurveyView, setShowSurveyView] = useState(false);
    const [showRegistration, setShowRegistration] = useState(false);
    const [showWaitlist, setShowWaitlist] = useState(false);
    const [reloadKey, setReloadKey] = useState(0);
    const [showSendReminder, setShowSendReminder] = useState(false);
    const [showSendLink, setShowSendLink] = useState(false);
    const [showSendSurvey, setShowSendSurvey] = useState(false);
    const [showSendCertificates, setShowSendCertificates] = useState(false);

    const [fetchUsers, setFetchUsers] = useState(false);

    const colSpan = 14;

    const sessionInfo = useContext(SessionContext);
    const sessionUser = sessionInfo?.user ? sessionInfo.user : null;

    const handleBulkSurveyClose = () => {
        setShowBulkSurvey(false);
    };

    useEffect(() => {
        setFetchUsers(open);
    }, [open]);

    return (
        <>
        <ConfirmSendReminder show={showSendReminder} onHide={() => setShowSendReminder(false)} courseEvent={rowData}/>
        <ConfirmSendLink show={showSendLink} onHide={() => setShowSendLink(false)} courseEvent={rowData}/>
        <ConfirmSendSurvey show={showSendSurvey} onHide={() => setShowSendSurvey(false)} courseEvent={rowData} />
        <ConfirmSendCertificates show={showSendCertificates} onHide={() => setShowSendCertificates(false)} courseEvent={rowData} />
        <BulkSurvey show={showBulkSurvey} onHide={handleBulkSurveyClose} courseEvent={rowData}/>
        <ManualRegistration show={showRegistration} onHide={() => setShowRegistration(false)} courseEvent={rowData} initiateReload={()=> {setReloadKey(prev => prev + 1)}}/>
        {/* enforce lazy loading for more data-heavy modals */}
        {showSurveyView && 
            <SurveyResponsesView show={showSurveyView} onHide={() => setShowSurveyView(false)} courseEvent={rowData}/>
        }
        {showWaitlist &&
            <WaitlistView show={showWaitlist} onHide={() => setShowWaitlist(false)} courseEvent={rowData} initiateReload={()=> {setReloadKey(prev => prev + 1)}} initiateParentReload={initiateParentReload}/>
        }
        <tr>
            <td colSpan={colSpan} style={{ padding: 0 }}>
                <Collapse in={open}>
                    <div id={`collapse-${i}`} style={{ padding: '10px 20px', background: '#f1f1f1'}}>
                        <Container fluid>
                            <Row>
                                <Col xs={3} sm={4} xl={12}>
                                    <Navbar expand="xl">
                                        <Navbar.Toggle aria-controls="responsive-navbar-nav" style={{marginBottom:"0.5em"}}/>
                                        <Navbar.Collapse className="course-menu">
                                            <Nav style={{width:"100%"}}>
                                                <ListGroup horizontal="xl" style={{paddingBottom:"1em", width:"100%"}}>
                                                    
                                                    <ListGroup.Item action className="p-2 list-item-hover" variant="primary" onClick={() => setShowSendReminder(true)}>
                                                        <Container fluid style={{padding:"0"}}>
                                                            <Row className="align-items-center justify-content-center">
                                                                <Col xs={1}><Bell size="20"/></Col>
                                                                <Col>Send Reminder</Col>
                                                            </Row>
                                                        </Container>
                                                    </ListGroup.Item>
                                                    <ListGroup.Item action className="p-2 list-item-hover" variant="primary" onClick={() => setShowSendLink(true)}>
                                                        <Container fluid style={{padding:"0"}}>
                                                            <Row className="align-items-center justify-content-center" >
                                                                <Col xs={1}><Link size="20"/></Col>
                                                                <Col>Send Link</Col>
                                                            </Row>
                                                        </Container>
                                                    </ListGroup.Item>
                                                    <ListGroup.Item action className="p-2 list-item-hover" variant="primary" onClick={() => setShowSendSurvey(true)}>
                                                        <Container fluid style={{padding:"0"}}>
                                                            <Row className="align-items-center justify-content-center" >
                                                                <Col xs={1}><ClipboardData size="20"/></Col>
                                                                <Col>Send Survey</Col>
                                                            </Row>
                                                        </Container>
                                                    </ListGroup.Item>
                                                    <ListGroup.Item action className="p-2 list-item-hover" variant="primary" onClick={() => setShowSurveyView(true)}>
                                                        <Container fluid style={{padding:"0"}}>
                                                            <Row className="align-items-center justify-content-center" >
                                                                <Col xs={1}><EnvelopePaper size="20"/></Col>
                                                                <Col>View Survey</Col>
                                                            </Row>
                                                        </Container>
                                                    </ListGroup.Item>
                                                    { sessionUser && sessionUser.user_role === 'Admin' &&
                                                    <>
                                                        <ListGroup.Item action className="p-2 list-item-hover" variant="primary" onClick={() => setShowSendCertificates(true)}>
                                                            <Container fluid style={{padding:"0"}}>
                                                                <Row className="align-items-center justify-content-center">
                                                                    <Col xs={1}><Mortarboard size="20"/></Col>
                                                                    <Col>Send Certificates</Col>
                                                                </Row>
                                                            </Container>
                                                        </ListGroup.Item>
                                                    
                                                        <ListGroup.Item action className="p-2 list-item-hover" variant="primary" onClick={() => setShowRegistration(true)}>
                                                            <Container fluid style={{padding:"0"}}>
                                                                <Row className="align-items-center justify-content-center">
                                                                    <Col xs={1}><PersonAdd size="20"/></Col>
                                                                    <Col>Manually Register</Col>
                                                                </Row>
                                                            </Container>
                                                        </ListGroup.Item>
                                                    </>
                                                    }
                                                    <ListGroup.Item action className="p-2 list-item-hover" variant="primary" onClick={() => setShowWaitlist(true)}>
                                                        <Container fluid style={{padding:"0"}}>
                                                            <Row className="align-items-center justify-content-center">
                                                                <Col xs={1}><Hourglass size="20"/></Col>
                                                                <Col>View Waitlist</Col>
                                                            </Row>
                                                        </Container>
                                                    </ListGroup.Item>
                                                    {sessionUser && sessionUser.user_role === 'Admin' &&
                                                        <ListGroup.Item action className="p-2 list-item-hover" variant="primary" onClick={() => setShowBulkSurvey(true)}>
                                                            <Container fluid style={{padding:"0"}}>
                                                                <Row className="align-items-center">
                                                                    <Col xs={1}><Collection size="20"/></Col>
                                                                    <Col>Bulk Survey Entry</Col>
                                                                </Row>
                                                            </Container>
                                                        </ListGroup.Item>
                                                    }
                                                </ListGroup>
                                            </Nav>
                                        </Navbar.Collapse>
                                    </Navbar>
                                </Col>
                            </Row>
                        </Container>
                        <UserRegistrationList key={reloadKey} courseEventId={rowData.course_event_id} initializeFetch={fetchUsers} initiateReloadInParent={initiateParentReload}/>
                    </div>
                </Collapse>
            </td>
        </tr>
        </>
    );
};